export default __webpack_public_path__ + "static/media/EcommerceWebDevimg2.0464894f.png";